import axios from "../helper/AxiosHelper";
import ApiHelper from "./ApiHelper";


const getSteminpeSkillList = async () => {
  const response = await axios.get("/skillInfo/getSkillListByProject/steminpe");
  return ApiHelper.processResponse(response);
};


export const InfoApi = {
  getSteminpeSkillList,
};
